import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
  Button,
  Label,
  Input,
  Row,
  Alert,
  Spinner,
} from "reactstrap";
import * as FaIcons from "react-icons/fa";
import axios from "axios";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import "jspdf-autotable";
import logos from "../../components/img/base/111.png";

const CargaDocA = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const abrirCerrarModalInsertar = () => {
    setModalInsertar(!modalInsertar);
  };
  const baseUrl = "https://bqef-bo.com/api/A/apiDash.php";
  ////Datos usuario Administrador
  const [dataPer, setDataPer] = useState({});
  const peticionGetAdm = async () => {
    setLoading(true);
    setError("");
    const adminId = sessionStorage.getItem("iduser");
    try {
      const res = await axios.get(`${baseUrl}?action=getInfoAdm&id=${adminId}`);
      const receivedData =
        res.data.InfoAdm && Array.isArray(res.data.InfoAdm)
          ? res.data.InfoAdm
          : [];
      // console.log(res.data);
      setDataPer(receivedData);
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ha ocurrido un error al cargar los datos.",
        footer: `Código de error: ${error.response.status}`,
      });
    }
  };
  //modal ver
  const [modalVer, setModalVer] = useState(false);
  const abrirCerrarModalVer = () => {
    setModalVer(!modalVer);
  };
  const [usuarioSeleccionado, setUsuarioSeleccionado] = useState({
    id_com: "",
    nom_doc: "",
    id_per: "",
    detalle: "",
    tipo_archivo: "",
    archivo_com: null,
  });

  // Definir un objeto de validación con patrones de expresiones regulares y estados de validación iniciales
  const validation = {
    nom_doc: { regex: /^[a-zA-Z0-9\s]{1,300}$/, isValid: true },
    detalle: { regex: /^[a-zA-Z0-9\s]{1,50}$/, isValid: true },
    archivo_com: { isValid: false },
  };

  const [isValid, setIsValid] = useState({
    nom_doc: true,
    detalle: true,
    archivo_com: false,
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    // Manejar cambio de texto
    setUsuarioSeleccionado((prevState) => ({ ...prevState, [name]: value }));
    if (validation[name] && validation[name].regex) {
      const isValidValue = validation[name].regex.test(value);
      setIsValid((prevState) => ({ ...prevState, [name]: isValidValue }));
    }
  };
  ////Fecha
  const [inicioFecha, setInicioFecha] = React.useState("");
  const [finFecha, setFinFecha] = React.useState("");
  const [fechaErrorIni, setFechaErrorIni] = React.useState(false);
  const [fechaErrorFin, setFechaErrorFin] = React.useState(false);
  const handleChangefechaInicio = (e) => {
    const value = e.target.value;
    // Validar que la fecha no sea vacía y que sea válida (puedes agregar más validaciones si quieres)
    if (!value) {
      setFechaErrorIni(true);
    } else {
      setFechaErrorIni(false);
    }
    setInicioFecha(value);
  };
  const handleChangefechaFin = (e) => {
    const value = e.target.value;
    // Validar que la fecha no sea vacía y que sea válida (puedes agregar más validaciones si quieres)
    if (!value) {
      setFechaErrorFin(true);
    } else {
      setFechaErrorFin(false);
    }
    setFinFecha(value);
  };

  ////Mostrar comunicados
  const [lista, setLista] = useState([]);
  const getComunicado = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await axios.get(`${baseUrl}?action=getConv`);
      const receivedData =
        res.data.Convocatorias && Array.isArray(res.data.Convocatorias)
          ? res.data.Convocatorias
          : [];
      // console.log(receivedData);
      setTablaUsuarios(receivedData);
      setLista(receivedData);
    } catch (error) {
      // Manejar errores de la solicitud
      setError("Error al cargar los datos");
      // console.error(error);
    } finally {
      setLoading(false);
    }
  };
  ////Agregar comunicado
  const [comunicado, setComunicado] = useState(null);
  async function addComunicado(e) {
    e.preventDefault();

    // Validar errores de fechas
    if (fechaErrorIni || fechaErrorFin || finFecha === "") {
      // No hacer nada o mostrar un mensaje
      return;
    }

    let fd = new FormData();
    if (comunicado) {
      fd.append("archivo_com", comunicado);
    }
    fd.append("detalle", usuarioSeleccionado.detalle);
    fd.append("tipo_archivo", usuarioSeleccionado.tipo_archivo);
    fd.append("nom_doc", usuarioSeleccionado.nom_doc);
    fd.append("fecha_inicio", inicioFecha);
    fd.append("fecha_fin", finFecha);

    if (Array.isArray(dataPer) && dataPer.length > 0 && dataPer[0].id_adm) {
      const idAdm = dataPer[0].id_adm;
      fd.append("nom_usu", idAdm);
    } else {
      console.error("No se encontró id_adm");
      return;
    }

    try {
      await axios.post(`${baseUrl}?action=addConv`, fd);
      mostrarAlertaN();
      abrirCerrarModalInsertar();
      getComunicado();
    } catch (error) {
      console.error("Error al subir el comunicado:", error);
    }
  }
  const seleccionarUsuario = (Usuario, caso) => {
    setUsuarioSeleccionado(Usuario);

    caso === "Editar" ? abrirCerrarModalVer() : abrirCerrarModalEliminar();
  };
  ////eliminar comunicado
  async function deleteComunicado(id_com) {
    const idAdm =
      Array.isArray(dataPer) && dataPer.length > 0 ? dataPer[0].id_adm : null;

    if (!idAdm) {
      console.error("No se encontró id_adm para eliminar");
      return;
    }

    try {
      const res = await axios.delete(
        `${baseUrl}?action=deleteConv&id_com=${id_com}&usu_modificacion=${idAdm}`,
      );
      abrirCerrarModalEliminar();
      getComunicado();
      mostrarAlertaD();
      console.log(res.data);
    } catch (error) {
      console.error("Error en peticion Delete:", error);
    }
  }
  ////
  const [modalInsertar, setModalInsertar] = useState(false);
  //modal eliminar
  const [modalEliminar, setModalEliminar] = useState(false);
  const abrirCerrarModalEliminar = () => {
    setModalEliminar(!modalEliminar);
  };

  //////Filtrar columnas
  const [sortField, setSortField] = useState(null);
  const [order, setOrder] = useState("asc");

  const handleSortingChange = (accessor) => {
    const sortOrder =
      accessor === sortField && order === "asc" ? "desc" : "asc";
    setSortField(accessor);
    setOrder(sortOrder);
  };

  const sortedData = lista.sort((a, b) => {
    if (a[sortField] < b[sortField]) {
      return order === "asc" ? -1 : 1;
    }
    if (a[sortField] > b[sortField]) {
      return order === "asc" ? 1 : -1;
    }
    return 0;
  });

  ////PDF
  const handleDescargarPdf = async () => {
    var link = document.createElement("a");
    // Se agregan los prefijos de href para indicar que el contenido que sigue está en formato PDF y
    // está codificado en Base64.
    link.setAttribute(
      "href",
      "data:application/pdf;base64," + usuarioSeleccionado.archivo_com,
    );
    link.setAttribute("download", usuarioSeleccionado.nom_doc);
    link.click();
  };
  useEffect(() => {
    getComunicado();
    peticionGetAdm();
  }, []);
  ////BARRA BUSQUEDA
  const [busqueda, setBusqueda] = useState("");
  const [tablaUsuarios, setTablaUsuarios] = useState([]);
  // const [usuarios, setUsuarios] = useState([]);

  const handleChangeB = (e) => {
    setBusqueda(e.target.value);
    filtrar(e.target.value);
  };

  const filtrar = (terminoBusqueda) => {
    const resultadosBusqueda = tablaUsuarios.filter((elemento) => {
      const nom_docMatch = elemento.nom_doc
        .toString()
        .toLowerCase()
        .includes(terminoBusqueda.toLowerCase());
      const detalleMatch = elemento.detalle
        .toString()
        .toLowerCase()
        .includes(terminoBusqueda.toLowerCase());
      const id_perMatch = elemento.id_per
        .toString()
        .toLowerCase()
        .includes(terminoBusqueda.toLowerCase());

      return nom_docMatch || detalleMatch || id_perMatch;
    });

    setLista(resultadosBusqueda);
  };
  var cont = 1;
  ////ALERTAS
  const mostrarAlertaN = () => {
    Swal.fire({
      confirmButtonColor: "#2E8B57",
      title: "Éxito!",
      text: "Registro Guardado.",
      timer: 5000,
      icon: "success",
    });
  };
  const mostrarAlertaD = () => {
    Swal.fire({
      confirmButtonColor: "#2E8B57",
      title: "Eliminado!",
      text: "Registro Eliminado.",
      timer: 5000,
      icon: "success",
    });
  };
  ///GENERAR PDF INFORME
  const generatePDF = () => {
    // Crear un nuevo documento PDF en orientación vertical
    const doc = new jsPDF("portrait");

    // Propiedades del documento (puedes incluir título, autor, etc.)
    doc.setProperties({
      title: "Reporte Carga Comunicado",
      author: "BQEF",
      subject: "Reporte de datos",
      keywords: "carga comunicado, reporte, datos",
      creator: "jsPDF",
    });

    // Agregar logo al documento PDF
    doc.addImage(logos, "PNG", 10, 10, 20, 10);

    // Establecer la fuente en negrita
    doc.setFont("helvetica", "bold");

    // Agregar título "FONDO DE EDUCACIÓN" al documento PDF
    doc.setFontSize(12);
    const title = "FONDO DE EDUCACION DE CUAQUEROS BOLIVIANOS";
    const titleWidth = doc.getTextWidth(title);
    const x = (doc.internal.pageSize.width - titleWidth) / 2; // Calcular posición X para centrar
    const y = 20; // Posición Y del título

    // Escribir el título
    doc.text(title, x, y);

    // Dibujar la línea subrayando el título
    doc.line(x, y + 1, x + titleWidth, y + 1); // Dibuja la línea

    // Restablecer la fuente a normal
    doc.setFont("helvetica", "normal");

    // Agregar subtítulo "Reporte" al documento PDF
    const subtitle = "Reporte Carga Comunicado";
    const subtitleWidth = doc.getTextWidth(subtitle);
    const subtitleX = (doc.internal.pageSize.width - subtitleWidth) / 2; // Calcular posición X para centrar
    doc.text(subtitle, subtitleX, 30);

    // Agregar fecha al documento PDF
    const fecha = new Date();
    const dia = fecha.getDate();
    const mes = fecha.getMonth() + 1;
    const año = fecha.getFullYear();
    doc.setFontSize(9);
    doc.text(`Fecha: ${dia}/${mes}/${año}`, 10, 25);

    // Establecer la fuente en negrita
    doc.setFont("helvetica", "bold");

    // Definir el texto "Usuario: "
    const usuarioText = "Usuario: Personal Administrativo";

    // Calcular el ancho del texto
    const usuarioWidth = doc.getTextWidth(usuarioText);

    // Calcular la posición X para alinearlo a la derecha
    const usuarioX = doc.internal.pageSize.width - usuarioWidth - 10; // 10 mm de margen desde el borde derecho

    // Escribir el texto "Usuario:" en la posición calculada
    doc.text(usuarioText, usuarioX, 35);

    // Definir los datos de la tabla
    const userData = lista
      .map((iteb) => ({
        nom_doc: `${iteb.nom_doc}`,
        id_per: iteb.id_per,
        detalle: iteb.detalle,
      }))
      .sort((a, b) => a.nom_doc.localeCompare(b.nom_doc)) // Ordenar por nombre en orden alfabético ascendente
      .map((iteb, nb) => ({
        it: nb + 1, // Asignar el índice de forma ascendente después de ordenar
        ...iteb, // Desestructurar el resto de las propiedades
      }));

    // Definir las columnas de la tabla
    const columns = [
      { header: "N°", dataKey: "it" },
      { header: "Nombre Documento", dataKey: "nom_doc" },
      { header: "ID Usuario", dataKey: "id_per" },
      { header: "Detalle", dataKey: "detalle" },
    ];

    // Agregar la tabla al documento PDF
    autoTable(doc, {
      columns: columns,
      body: userData,
      startY: 40,
      margin: { top: 20, bottom: 20 },
      bodyStyles: { fontSize: 8 },
      headStyles: { fontSize: 9, fillColor: [10, 49, 67] },
    });

    // Agregar número de página al documento PDF
    let totalPages = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFontSize(9);
      doc.text(
        `Página ${i} de ${totalPages}`,
        10,
        doc.internal.pageSize.height - 10,
      );
    }

    // Convertir el documento PDF a blob
    const pdfBlob = doc.output("blob");

    // Abrir el PDF en una nueva ventana
    const url = URL.createObjectURL(pdfBlob);
    window.open(url, "_blank");
  };
  ////Carga
  if (loading) {
    return (
      <div className="text-center my-5">
        <Spinner color="primary" />
        Cargando...
      </div>
    );
  }

  if (error) {
    return <Alert color="danger">{error}</Alert>;
  }
  return (
    <div id="main_content">
      <div className="tra">
        <div className="tra title-form">
          <h2>Gestión Documentos</h2>
        </div>
        <div className="frm">
          <Button
            color="success"
            size="lg"
            onClick={() => abrirCerrarModalInsertar()}
          >
            <FaIcons.FaPlus /> Añadir
          </Button>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <Button color="primary" size="lg" onClick={generatePDF}>
            <FaIcons.FaFileDownload /> Reporte
          </Button>
        </div>
        <div className="frm containerInput">
          <Input
            className="form-control inputBuscar"
            bsSize="lg"
            value={busqueda}
            placeholder="Búsqueda por Nombre o ID Usuario"
            onChange={handleChangeB}
          />
          <Button className="btn btn-success" size="lg">
            <FaIcons.FaSearch /> Buscar
          </Button>
          <br />
        </div>

        <Table className="frm" responsive="sm" id="tabl">
          <thead id="stahead">
            <tr className="text-center">
              <th>N°</th>
              <th>
                <span onClick={() => handleSortingChange("nom_doc")}>
                  Nombre documento
                  {sortField === "nom_doc" && order === "asc" ? (
                    <FaIcons.FaSortUp />
                  ) : sortField === "nom_doc" && order === "desc" ? (
                    <FaIcons.FaSortDown />
                  ) : (
                    <FaIcons.FaSort />
                  )}
                </span>
              </th>
              <th>
                <span onClick={() => handleSortingChange("id_per")}>
                  ID Usuario
                  {sortField === "id_per" && order === "asc" ? (
                    <FaIcons.FaSortUp />
                  ) : sortField === "id_per" && order === "desc" ? (
                    <FaIcons.FaSortDown />
                  ) : (
                    <FaIcons.FaSort />
                  )}
                </span>
              </th>
              <th>
                <span onClick={() => handleSortingChange("detalle")}>
                  Detalle
                  {sortField === "detalle" && order === "asc" ? (
                    <FaIcons.FaSortUp />
                  ) : sortField === "detalle" && order === "desc" ? (
                    <FaIcons.FaSortDown />
                  ) : (
                    <FaIcons.FaSort />
                  )}
                </span>
              </th>
              <th>
                <span onClick={() => handleSortingChange("fecha_inicio")}>
                  Fecha de inicio
                  {sortField === "fecha_inicio" && order === "asc" ? (
                    <FaIcons.FaSortUp />
                  ) : sortField === "fecha_inicio" && order === "desc" ? (
                    <FaIcons.FaSortDown />
                  ) : (
                    <FaIcons.FaSort />
                  )}
                </span>
              </th>
              <th>
                <span onClick={() => handleSortingChange("fecha_fin")}>
                  Fecha de fin
                  {sortField === "fecha_fin" && order === "asc" ? (
                    <FaIcons.FaSortUp />
                  ) : sortField === "fecha_fin" && order === "desc" ? (
                    <FaIcons.FaSortDown />
                  ) : (
                    <FaIcons.FaSort />
                  )}
                </span>
              </th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {sortedData.map((item, n2) => (
              <tr className="text-center" key={item.id_com}>
                <td>{cont++}</td>
                <td>{item.nom_doc}</td>
                <td>{item.id_per}</td>
                <td>{item.detalle}</td>
                <td>{item.fecha_inicio}</td>
                <td>{item.fecha_fin}</td>
                <td>
                  <Button
                    color="warning"
                    onClick={() => seleccionarUsuario(item, "Editar")}
                  >
                    <FaIcons.FaRegEye />
                    &nbsp;&nbsp;Visualizar
                  </Button>
                  &nbsp;&nbsp;&nbsp;
                  <Button
                    color="danger"
                    onClick={() => seleccionarUsuario(item, "Eliminar")}
                  >
                    Eliminar
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        {/* Modal agregar comunicado */}
        <Modal isOpen={modalInsertar} toggle={abrirCerrarModalInsertar}>
          <ModalHeader className="header_mo">Cargar documento</ModalHeader>
          <ModalBody>
            <div className="form-group">
              {/* Nuevo select para "Convocatoria" o "Comunicado" */}
              <Label>Tipo de documento:</Label>
              <br />
              <Input
                type="select"
                name="tipo_archivo"
                value={usuarioSeleccionado.tipo_archivo}
                onChange={handleChange}
                className="form-control"
              >
                <option value="">Seleccione una opción</option>
                <option value="convocatoria">Convocatoria</option>
                <option value="comunicado">Comunicado</option>
              </Input>
              {/* Puedes agregar validación si deseas */}

              {/* Resto de tu formulario */}

              <Label>Nombre documento: </Label>
              <br />
              <Input
                type="text"
                className="form-control"
                name="nom_doc"
                value={usuarioSeleccionado.nom_doc}
                onChange={handleChange}
              />
              {!isValid.nom_doc && (
                <span style={{ color: "red" }}>
                  El texto debe tener como máximo 20 letras y espacios
                </span>
              )}
              <br />
              <Label>Usuario: </Label>
              <br />
              <Input
                disabled
                type="text"
                className="form-control"
                name="nom_usu"
                value={`${dataPer[0].nombre} ${dataPer[0].apellido}`}
              />
              <br />
              <Label>Informe personal: </Label>
              <br />
              <Input
                type="file"
                className="form-control"
                accept="archivo_com/*"
                onChange={(e) => setComunicado(e.target.files[0])}
                multiple
              />
              <br />
              <Label>Fecha Inicio: </Label>
              <br />
              <Input
                type="date"
                className="form-control"
                name="fecha_inicio"
                value={inicioFecha}
                onChange={handleChangefechaInicio}
              />
              <br />
              <Label>Fecha Fin: </Label>
              <br />
              <Input
                type="date"
                className="form-control"
                name="fecha_fin"
                value={finFecha}
                onChange={handleChangefechaFin}
              />
              <br />
              <Label>Detalle: </Label>
              <br />
              <textarea
                type="text"
                className="form-control"
                name="detalle"
                value={usuarioSeleccionado.detalle}
                onChange={handleChange}
              />
              {!isValid.detalle && (
                <span style={{ color: "red" }}>
                  El texto debe tener como máximo 50 letras y espacios
                </span>
              )}
              <br />
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              color="success"
              size="lg"
              onClick={(e) => addComunicado(e)}
              disabled={!isValid.nom_doc || !isValid.detalle}
            >
              Guardar
            </Button>
            <Button
              color="danger"
              size="lg"
              onClick={() => abrirCerrarModalInsertar()}
            >
              Cancelar
            </Button>
          </ModalFooter>
        </Modal>
        {/* Modal Eliminar */}
        <Modal isOpen={modalEliminar} toggle={abrirCerrarModalEliminar}>
          <ModalHeader className="header_mo">Eliminar comunicado</ModalHeader>
          <ModalBody>
            ¿Estás seguro que deseas eliminar el documento{" "}
            {usuarioSeleccionado && usuarioSeleccionado.nom_doc}?
          </ModalBody>
          <ModalFooter>
            <Button
              color="success"
              size="lg"
              onClick={() => deleteComunicado(usuarioSeleccionado.id_com)}
            >
              Sí
            </Button>
            <Button
              color="danger"
              size="lg"
              onClick={() => abrirCerrarModalEliminar()}
            >
              No
            </Button>
          </ModalFooter>
        </Modal>

        {/* Modal VER */}
        <Modal isOpen={modalVer} toggle={abrirCerrarModalVer} size="xl">
          <ModalHeader className="header_mo">
            {usuarioSeleccionado && usuarioSeleccionado.nom_doc}
          </ModalHeader>
          <ModalBody>
            <Card>
              <CardBody className="p-0">
                <Row className="justify-content-center">
                  <object
                    data={
                      "data:application/pdf;base64," +
                      usuarioSeleccionado.archivo_com
                    }
                    type="application/pdf"
                    alt="archivo_per"
                    width="400"
                    height="600"
                  >
                    <p>
                      Tu navegador no puede mostrar este archivo PDF. Puedes
                      descargarlo
                      <a
                        href={
                          "data:application/pdf;base64," +
                          usuarioSeleccionado.archivo_com
                        }
                        download
                      >
                        aquí
                      </a>
                      .
                    </p>
                  </object>
                </Row>
              </CardBody>
            </Card>
          </ModalBody>
          <ModalFooter>
            <Button
              style={{ float: "right" }}
              color="success"
              size="lg"
              onClick={handleDescargarPdf}
            >
              <FaIcons.FaDownload />
              Download
            </Button>
            <Button
              color="danger"
              size="lg"
              onClick={() => abrirCerrarModalVer()}
            >
              Cancelar
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </div>
  );
};

export default CargaDocA;
